<template>
	<div class="ReSelectDistrict">
		<div v-if="typeof CAT_DIST != 'undefined'">
			<div class="col-6 ">
				<el-checkbox class="mb-4" :indeterminate="isIndeterminateSPB" v-model="checkAllSPB" @change="handleCheckAllChangeSPB">Санкт-Петербург</el-checkbox>
				<el-checkbox-group v-model="value.all" @change="handleCheckedChangeSPB">
					<el-checkbox v-for="district in CAT_DIST.SPB" :label="district.id" :key="district.id">{{$GVO.str_replace(' р-н','',district.name)}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<div class="col-6">
				<el-checkbox class="mb-4" :indeterminate="isIndeterminateLO" v-model="checkAllLO" @change="handleCheckAllChangeLO">Ленинградская область</el-checkbox>
				<el-checkbox-group v-model="value.all" @change="handleCheckedChangeLO">
					<el-checkbox v-for="district in CAT_DIST.LO" :label="district.id" :key="district.id">{{$GVO.str_replace(' р-н','',district.name)}}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div v-else>Загрузка справочника...</div>
	</div>
</template>

<script>
	import { CheckboxGroup, Checkbox } from 'element-ui';
	export default {
		name: 'ReSelectDistrict',
		components: {
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
		},
		props: {
			value: {
				type: Object,
				default(){
					return {
						all: [],
					}
				}
			},
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				CAT_DIST: this.$GVO.cats.CAT_DIST,
				cat_timer: null,
				checkAllSPB: false,
				checkAllLO: false,
				masAllDistrictSPB: [],
				masAllDistrictLO: [],
				isIndeterminateSPB: false,
				isIndeterminateLO: false
			}
		},
		computed: {
			
		},
		methods: {
			handleCheckAllChangeSPB(val) {
				//this.value.all = val ? this.masAllDistrictSPB : [];
				if(val){
					this.value.all = [...this.value.all, ...this.masAllDistrictSPB];
				}else{
					this.value.all = this.value.all.filter(n => !this.masAllDistrictSPB.includes(n));
				}
				this.isIndeterminateSPB = false;
			},
			handleCheckAllChangeLO(val) {
				//this.value.all = val ? this.masAllDistrictLO : [];
				if(val){
					this.value.all = [...this.value.all, ...this.masAllDistrictLO];
				}else{
					this.value.all = this.value.all.filter(n => !this.masAllDistrictLO.includes(n));
				}
				this.isIndeterminateLO = false;
			},
			handleCheckedChangeSPB(value) {
				let checkedCount = value.filter(n => this.masAllDistrictSPB.includes(n)).length;
				this.checkAllSPB = checkedCount === this.CAT_DIST.SPB.length;
				this.isIndeterminateSPB = checkedCount > 0 && checkedCount < this.CAT_DIST.SPB.length;
			},
			handleCheckedChangeLO(value) {
				let checkedCount = value.filter(n => this.masAllDistrictLO.includes(n)).length;
				this.checkAllLO = checkedCount === this.CAT_DIST.LO.length;
				this.isIndeterminateLO = checkedCount > 0 && checkedCount < this.CAT_DIST.LO.length;
			}
		},
		created() {
			this.cat_timer = setInterval(() => {
				//console.log('cat_timer');
				if (typeof this.$GVO.cats.CAT_DIST != 'undefined') {
					this.CAT_DIST = {'SPB':[],'LO':[]}
					for (let i = 0; i < this.$GVO.cats.CAT_DIST.length; i++) {
						if(this.$GVO.cats.CAT_DIST[i].region_id == 2){
							this.CAT_DIST.LO.push(this.$GVO.cats.CAT_DIST[i]);
							this.masAllDistrictLO.push(this.$GVO.cats.CAT_DIST[i].id);
						}else if(this.$GVO.cats.CAT_DIST[i].region_id == 1){
							this.CAT_DIST.SPB.push(this.$GVO.cats.CAT_DIST[i]);
							this.masAllDistrictSPB.push(this.$GVO.cats.CAT_DIST[i].id);
						}
					}
					let checkedCount = this.value.all.filter(n => this.masAllDistrictSPB.includes(n)).length;
					this.checkAllSPB = checkedCount === this.CAT_DIST.SPB.length;
					this.isIndeterminateSPB = checkedCount > 0 && checkedCount < this.CAT_DIST.SPB.length;
					
					checkedCount = this.value.all.filter(n => this.masAllDistrictLO.includes(n)).length;
					this.checkAllLO = checkedCount === this.CAT_DIST.LO.length;
					this.isIndeterminateLO = checkedCount > 0 && checkedCount < this.CAT_DIST.LO.length;

					clearTimeout(this.cat_timer);
					this.cat_timer = null;
				}
			}, 250);
		}
	}
</script>
<style scoped>
	.ReSelectDistrict > div{
		display: flex;
		align-content: space-between;
	}
	.ReSelectDistrict > div > *{
		display: inline-block;
	}
	.ReSelectDistrict .el-checkbox-group .el-checkbox{
		display: block;
	}
	@media (max-width: 470px){
		.ReSelectDistrict > div{
			flex-direction: column;
		}
		.ReSelectDistrict > div > div:nth-child(2){
			margin-top: 15px;
		}
	}
</style>
